import type { RouteRecordRaw } from 'vue-router';
import { campaignCreateGuard, campaignEditGuard } from './route-guards';

export const routes: RouteRecordRaw[] = [
  {
    path: 'campaigns/add',
    name: 'campaign-add',
    component: () => import('./create-campaigns.vue'),
    props: true,
    beforeEnter: campaignCreateGuard,
  },
  {
    path: 'campaigns/:campaignId',
    name: 'campaign-edit',
    component: () => import('./create-campaigns.vue'),
    props: true,
    beforeEnter: campaignEditGuard,
  },
];
